import {MediaItem} from '@common/player/media-item';

export function isSameMedia(a?: MediaItem, b?: MediaItem): boolean {
  if (!a || !b) return false;
  return normalizeMediaId(a.id) === normalizeMediaId(b.id) && normalizeMediaId(a.groupId) === normalizeMediaId(b.groupId);
}

function normalizeMediaId(value: string | number | undefined): string {
  return value == null ? '' : `${value}`;
}
